import { h } from 'preact'
import { common } from '../common'
import { TopicInfo } from './TopicListItemView'

const isAbsoluteUrl = (imgUrl: string) => imgUrl.indexOf('://') > 0

const isContainingCdn = (imgUrl: string, attachmentCdn: string) => imgUrl.includes(attachmentCdn)

export const getImageUrl = (img: string, width: string, attachmentCdn: string) => {
  const isAbsoluteImgUrl = isAbsoluteUrl(img)
  const isImgUrlContainingCdn = isContainingCdn(img, attachmentCdn)

  if (isAbsoluteImgUrl && !isImgUrlContainingCdn) {
    return img
  }

  if (isAbsoluteImgUrl && isImgUrlContainingCdn) {
    img = img.replace(attachmentCdn, '')
  }

  return attachmentCdn + 'width/' + width + '/' + img
}

interface TopicContentProps {
  topic: TopicInfo
  attachmentCdn: string
}

const TopicContent = ({ topic, attachmentCdn }: TopicContentProps) => {
  const isNewTopicListViewEnabled = common.isModuleActive('topicItemView')

  const trimmedContent = topic.relevantPost.content.trim().substr(0, 1000)

  return topic.featuredImage
    ? (<div class='thread-list-block__article-wrapper'>
      {
        !isNewTopicListViewEnabled
          ? (
            <a
              className='thread-list-block__featured-image-link'
              href={topic.url}
              style={{
                backgroundImage: `url(${getImageUrl(topic.featuredImage, '480',
                  attachmentCdn)})`
              }}
            />
            )
          : null
      }
      <div class='thread-list-block__article-excerpt'>
        <p class={'thread-list-block__content' + (topic.featuredImage ? ' thread-list-block__content--article' : '') + ' qa-topic-content'}>
          <a href={topic.url} dangerouslySetInnerHTML={{ __html: trimmedContent }} />
        </p>
      </div>
    </div>)
    : (<p class='thread-list-block__content qa-topic-content'>
      <a href={topic.url} dangerouslySetInnerHTML={{ __html: trimmedContent }} />
    </p>)
}

export default TopicContent
